import { render } from "./AlzataPaginator.vue?vue&type=template&id=56a3b48f"
import script from "./AlzataPaginator.vue?vue&type=script&lang=js"
export * from "./AlzataPaginator.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__